import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import {OfferTitle, StyledSpecialOffer, OfferContent} from './LandingPanel.style';
import Promotions from '../../components/Promotions/Promotions';
import {SpecialOfferIcon} from './SpecialOfferIcon';

export const SpecialOffer = props => {
  const {promotions, black} = props;
  return (
    <StyledSpecialOffer
      black={black}
      data-rw="special-offer"
    >
      <SpecialOfferIcon black={black} />
      <OfferContent black={black}>
        <OfferTitle>
          <FormattedMessage id="home.specialOffer" />
        </OfferTitle>
        <Promotions
          promotions={promotions}
          page="menu"
          textOnly={true}
        />
      </OfferContent>
    </StyledSpecialOffer>
  );
};

SpecialOffer.propTypes = {
  promotions: PropTypes.object.isRequired,
  black: PropTypes.bool
};



// WEBPACK FOOTER //
// ./containers/LightHomePage/SpecialOffer.js